import React from 'react';
import { motion } from 'framer-motion';

const ProductCard = ({ product, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group flex flex-col bg-white border border-zinc-200 rounded-xl overflow-hidden hover:shadow-2xl hover:shadow-zinc-950/5 transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-100">
        <img 
          src={product.image} 
          alt={product.title} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-zinc-950/0 group-hover:bg-zinc-950/10 transition-colors duration-300" />
      </div>

      <div className="p-6 flex flex-col flex-grow">
        <div className="flex justify-between items-start gap-4 mb-2">
          <h3 className="text-xl font-bold text-zinc-950 leading-tight">
            {product.title}
          </h3>
          <span className="inline-block bg-zinc-100 text-zinc-900 font-semibold px-3 py-1 rounded-full text-sm shrink-0">
            {product.price}
          </span>
        </div>
        
        <p className="text-zinc-600 text-sm mb-8 flex-grow">
          {product.description}
        </p>

        <a 
          href={product.url} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="mt-auto w-full flex items-center justify-center bg-black text-white hover:bg-gray-800 font-bold py-3 px-4 rounded-lg transition-all"
        >
          Get it now
        </a>
      </div>
    </motion.div>
  );
};

export default ProductCard;